import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { ClaudeCodeByModelPoint } from '@ace-tracker/shared';
import { chartAxisTickProps, chartLegendProps, chartTooltipProps } from '../chartTheme';

/**
 * Per-model token composition — input, output, cache-created, and
 * cache-read tokens stacked per model. Claude Code only: Copilot's
 * CopilotUsageRecord has no cache measurement to break out this way.
 */
export function TokenCompositionChart({ byModel }: { byModel: ClaudeCodeByModelPoint[] }) {
  const sorted = [...byModel].sort(
    (a, b) =>
      b.inputTokens + b.outputTokens + b.cacheCreationTokens + b.cacheReadTokens - (a.inputTokens + a.outputTokens + a.cacheCreationTokens + a.cacheReadTokens),
  );

  if (sorted.length === 0) {
    return <p className="flex h-full items-center justify-center text-sm text-text-muted">No token usage in this range.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={sorted} layout="vertical" margin={{ left: 8 }} accessibilityLayer>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--line-soft)" />
        <XAxis type="number" {...chartAxisTickProps} />
        <YAxis type="category" dataKey="model" width={140} {...chartAxisTickProps} />
        <Tooltip {...chartTooltipProps} />
        <Legend {...chartLegendProps} />
        <Bar dataKey="inputTokens" stackId="tokens" fill="#0058AB" name="Input" />
        <Bar dataKey="outputTokens" stackId="tokens" fill="#06D6A0" name="Output" />
        <Bar dataKey="cacheCreationTokens" stackId="tokens" fill="#7B2FBE" name="Cache created" />
        <Bar dataKey="cacheReadTokens" stackId="tokens" fill="#00B4D8" name="Cache read" />
      </BarChart>
    </ResponsiveContainer>
  );
}
